import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/vendor/${':vendorId' | `${number}?uniqueId=${string}`}`;

export const ROUTE: RouteDefinition = `${baseRoute}/vendor/:vendorId`;

export const URL = (vendorId: number, vendorUniqueId: string): RouteDefinition => `${baseRoute}/vendor/${vendorId}?uniqueId=${vendorUniqueId}`;
